export default __webpack_public_path__ + "static/media/huddle.92c76866.png";